import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  Tooltip,
  IconButton,
  Fab,
} from "@mui/material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { DataGrid } from "@mui/x-data-grid";
import { useContext, useState, useEffect } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import { saveEntregaArticulos } from "../../../project/services/EntregaArticuloService";
import { getClienteByDocument } from "../../../project/services/ClienteService";
import { getTiposDocumentos } from "../../../project/services/TipoDocumentoService";
import Message from "../../../project/utils/Message";
import { isPositiveInteger } from "./../../../project/utils/utils";
import EntregaArticuloDialog from "./EntregaArticuloDialog";
import EntregaDetalleDialog from "./EntregaDetalleDialog";
// 
// ################################################################################
//
const EntregaArticulos = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [openDialogEntregaArticulo, setOpenDialogEntregaArticulo] = useState(false);
  const [articuloAEntregar, setArticuloAEntregar] = useState({});
  const [openDialogEntregaDetalle, setOpenDialogEntregaDetalle] = useState(false);
  const [entregaArticulosDetalle, setEntregaArticulosDetalle] = useState({});
  const [entregaArticulosAction, setEntregaArticulosAction] = useState("");
  const [tiposDocumentos, setTiposDocumentos] = useState([]);

  const {
    setIsDoingSomething,
    gaAction,
    articulosParaEntregarRows,
    entregasArticulosRows,
    entregarArticulos,
    entregaArticulos,
    setEntregaArticulos,
    handleChangeEntregaArticulos,
  } = useContext(GestionAtencionContext);

  const articulosParaEntregarTableColumns = [
    {
      field: "tipoArticulo",
      headerName: "Tipo",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.tipoArticulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "codigo",
      headerName: "Código",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion",
      headerName: "Descripción",
      headerAlign: "center",
      flex: 1,
      minWidth: 500,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cantidadVendida",
      headerName: "Vendido",
      type: "number",
      align: "right",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidadVendida;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cantidadPendienteEntrega",
      headerName: "Para entregar",
      type: "number",
      align: "right",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidadPendienteEntrega;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cantidadEntregada",
      headerName: "Entregado",
      type: "number",
      align: "right",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidadEntregada;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cantidadRestante",
      headerName: "Restante",
      type: "number",
      align: "right",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidadRestante;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "center",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {params.row.cantidadRestante > 0 && (
            <Tooltip title="entregar">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => handleActionEntrega(params.row, "deliver")}
              >
                <EastOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.cantidadEntregada > 0 && (
            <Tooltip title="borrar lo entregado">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => handleActionEntrega(params.row, "delete")}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const entregasArticulosTableColumns = [
    {
      field: "fechaCreacion",
      headerName: "Fecha de Entrega",
      flex: 1,
      headerAlign: "center",
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fechaCreacion;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cliente",
      headerName: "Cliente que retiró",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.nombreCliente + " " + params.row.apellidoCliente;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "sucursalEntrega",
      headerName: "Sucursal de entrega",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.areaDescripcion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "usuarioEntrega",
      headerName: "Entregado por",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.nombreUsuario + " " + params.row.apellidoUsuario;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "estado",
      headerName: "Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.estado;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "center",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {params.row.ultimoEstado === true && params.row.estado === "activo" && (
            <Tooltip title="anular entrega">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => handleActionVerDetallesEntrega(params.row, "delete")}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}

          <Tooltip title="ver detalles de la entrega">
            <IconButton
              size="small"
              aria-label="update"
              onClick={() => handleActionVerDetallesEntrega(params.row, "view")}
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    loadTiposDocumentos();
  }, []);
  //
  // ################################################################################
  //
  const loadTiposDocumentos = async () => {
    const response = await getTiposDocumentos();
    if (response.ok) {
      setTiposDocumentos(response.data.data);
    } else {
      setTiposDocumentos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    if (Object.keys(articuloAEntregar).length !== 0) {
      entregarArticulos(articuloAEntregar, "deliver");
    }
  }, [articuloAEntregar]);
  //
  // ################################################################################
  //
  const buscarCliente = () => {
    if (entregaArticulos.retiraTipoDocumento === "") {
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar el tipo de documento del Cliente",
      });
      setShowMessage(true);
      return;
    }

    if (!isPositiveInteger(entregaArticulos.retiraNumeroDocumento) || entregaArticulos.retiraNumeroDocumento.length < 7) {
      setMessage({
        severity: "error",
        messageText: "El documento del Cliente debe ser un número de 7 o más dígitos",
      });
      setShowMessage(true);
      return;
    }

    const loadCliente = async () => {
      let _params = {
        tipoDocumento: entregaArticulos.retiraTipoDocumento,
        numeroDocumento: entregaArticulos.retiraNumeroDocumento,
      };

      setIsDoingSomething(true);
      const response = await getClienteByDocument(_params);
      setIsDoingSomething(false);

      if (response.ok) {
        if (response.exist) {
          // si existe el cliente

          setEntregaArticulos({
            ...entregaArticulos,
            retiraNombre: response.data.data.nombre,
            retiraApellido: response.data.data.apellido,
            retiraTipoNumeroDocumentoDisabled: true,
            retiraNombreApellidoDisabled: true,
          })
        } else {
          // si no existe el cliente
          setEntregaArticulos({
            ...entregaArticulos,
            retiraNombre: "",
            retiraApellido: "",
            retiraTipoNumeroDocumentoDisabled: true,
            retiraNombreApellidoDisabled: false,
          })
        }
      } else {
        setMessage({
          messageText: response.messageText,
          severity: response.messageSeverity,
        });
        setShowMessage(true);
      }
    };
    loadCliente();
  };
  //
  // ################################################################################
  //
  const limpiarCliente = () => {
    setEntregaArticulos({
      ...entregaArticulos,
      retiraTipoDocumento: "",
      retiraNumeroDocumento: "",
      retiraTipoNumeroDocumentoDisabled: false,
      retiraNombre: "",
      retiraApellido: "",
      retiraNombreApellidoDisabled: true,
    });
  };
  //
  // ################################################################################
  //
  const handleActionEntrega = (parRow, parAction) => {
    if (parAction === "entregar-todo" || parAction === "delete") {
      entregarArticulos(parRow, parAction);
    } else {
      // deliver

      if (parRow.cantidadPendienteEntrega === 1) {
        // si solo hay un artículo pendiente de entrega, lo entrego directamente

        const _articuloAEntregar = {
          ...parRow,
          cantidadEntregada: 1,
          cantidadRestante: 0,
        };
        entregarArticulos(_articuloAEntregar, "deliver");
      } else {
        // si hay mas de un articulo pendiente de entrega, abro el dialogo para que ingrese la cantidad a entregar

        setArticuloAEntregar(parRow);
        setOpenDialogEntregaArticulo(true);
      }
    }
  };
  //
  // ################################################################################
  //
  const handleActionVerDetallesEntrega = (parRow, parAction) => {
    setEntregaArticulosAction(parAction);
    setEntregaArticulosDetalle(parRow);
    setOpenDialogEntregaDetalle(true);
  };
  //
  // ################################################################################
  //
  const handleEntregaDetalleDialogClose = () => {
    setOpenDialogEntregaDetalle(false);
  }
  //
  // ################################################################################
  //
  const handleEntregaArticuloDialogClose = () => {
    setOpenDialogEntregaArticulo(false);
  }
  //
  // ################################################################################
  //
  const handleEntregaArticuloDialogSave = () => {
    setOpenDialogEntregaArticulo(false);
  }
  //
  // ################################################################################
  //
  const handleSave = () => {

    if (entregaArticulos.totalArticulosEntregados === 0) {

      setMessage({
        messageText: "Debes entregar al menos un artículo",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (entregaArticulos.retiraTipoDocumento === "" || entregaArticulos.retiraNumeroDocumento === "" || entregaArticulos.retiraNombre === "" || entregaArticulos.retiraApellido === "") {
      // si el usuario no completo los datos de la persona que retira

      setMessage({
        messageText: "Debes completar los datos de la persona que retira los artículos",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    save();
  };
  //
  // ################################################################################
  //
  const save = async () => {

    const _entrega_item_list = [];
    articulosParaEntregarRows.forEach((item) => {
      if (item.cantidadEntregada > 0) {
        _entrega_item_list.push({
          tipo: item.tipoArticulo,
          id_gc_anteojo: item.idGcAnteojo,
          id_gc_arreglo: item.idGcArreglo,
          id_gc_otro_producto: item.idGcOtroProducto,
          id_gc_lente_contacto: item.idGcLenteContacto,
          cantidad_entregada: item.cantidadEntregada,
        });
      }
    })

    const _entregaArticulos = {
      id_gc: gaAction.idGestionAtencion,
      id_tipo_documento: entregaArticulos.retiraTipoDocumento,
      numero_documento: entregaArticulos.retiraNumeroDocumento,
      nombre: entregaArticulos.retiraNombre,
      apellido: entregaArticulos.retiraApellido,
      observaciones: entregaArticulos.retiraObservaciones,
      entrega_item_list: _entrega_item_list,
    };

    setIsDoingSomething(true);
    const response = await saveEntregaArticulos(_entregaArticulos);
    setIsDoingSomething(false);

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);

    if (response.ok) {
      setTimeout(() => {
        navigate("/gestion-atencion-table");
      }, 1500);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Box>
        <Paper elevation={3} sx={{ m: 1, p: 2 }}>

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                sx={{ mb: 1, ml: 2 }}
              >
                Artículos para entregar
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ display: "flex", justifyContent: "flex-end", mr: 1, mb: 1 }}>
                <Button
                  variant="contained"
                  onClick={() => entregarArticulos("", "entregar-todo")}
                  disabled={articulosParaEntregarRows.length === 0 || entregaArticulos.totalArticulosPendienteEntrega === entregaArticulos.totalArticulosEntregados}
                >
                  Entregar todo lo pendiente
                </Button>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ ml: 2, mr: 1, mb: 1 }}>
                <DataGrid
                  rows={articulosParaEntregarRows}
                  columns={articulosParaEntregarTableColumns}
                  {...tableOptions}
                />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ ml: 2 }}>
                <Typography variant="body1" display="block" gutterBottom>
                  Total de items entregados:{" "}
                  <Typography
                    component="span"
                    color="primary"
                    fontWeight={600}
                  >
                    {entregaArticulos.totalArticulosEntregados}
                  </Typography>
                </Typography>
              </Box>
            </Grid>

            <Box sx={{ ml: 1, mr: 3, width: "100%" }} >
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{ mb: 1, ml: 2 }}
                  >
                    Retira
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormControl
                    disabled={entregaArticulos.retiraTipoNumeroDocumentoDisabled}
                    sx={{ ml: 2, mb: 1, width: "100%" }}
                  >
                    <InputLabel id="tipo-documento-select-label">Tipo de Documento</InputLabel>
                    <Select
                      labelId="tipo-documento-select-label"
                      id="tipo-documento-select"
                      name="retiraTipoDocumento"
                      value={tiposDocumentos.length > 0 ? entregaArticulos.retiraTipoDocumento : ""}
                      label="Tipo de documento"
                      size="small"
                      onChange={handleChangeEntregaArticulos}
                    >
                      {tiposDocumentos.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <TextField
                    sx={{ ml: 2, mb: 1, width: "100%" }}
                    inputProps={{
                      autoComplete: "off",
                    }}
                    id="numero-documento"
                    label="Número"
                    variant="outlined"
                    size="small"
                    disabled={entregaArticulos.retiraTipoNumeroDocumentoDisabled}
                    name="retiraNumeroDocumento"
                    value={entregaArticulos.retiraNumeroDocumento}
                    onChange={handleChangeEntregaArticulos}
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <Tooltip title="buscar">
                    <span>
                      <Fab
                        sx={{ ml: 2, mb: 1 }}
                        color="primary"
                        aria-label="add"
                        size="small"
                        onClick={buscarCliente}
                        disabled={entregaArticulos.retiraTipoNumeroDocumentoDisabled}
                      >
                        <SearchIcon />
                      </Fab>
                    </span>
                  </Tooltip>

                  <Tooltip title="limpiar">
                    <span>
                      <Fab
                        sx={{ ml: 2, mb: 1 }}
                        color="outlined"
                        aria-label="add"
                        size="small"
                        onClick={limpiarCliente}
                        disabled={!entregaArticulos.retiraTipoNumeroDocumentoDisabled}
                      >
                        <CleaningServicesIcon />
                      </Fab>
                    </span>
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    sx={{ ml: 2, mb: 1 }}
                    fullWidth
                    inputProps={{
                      autoComplete: "off",
                    }}
                    id="retiraNombre"
                    label="Nombre"
                    variant="outlined"
                    size="small"
                    name="retiraNombre"
                    value={entregaArticulos.retiraNombre}
                    onChange={handleChangeEntregaArticulos}
                    disabled={entregaArticulos.retiraNombreApellidoDisabled}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    sx={{ ml: 2, mb: 1 }}
                    fullWidth
                    inputProps={{
                      autoComplete: "off",
                    }}
                    id="retiraApellido"
                    label="Apellido"
                    variant="outlined"
                    size="small"
                    name="retiraApellido"
                    value={entregaArticulos.retiraApellido}
                    onChange={handleChangeEntregaArticulos}
                    disabled={entregaArticulos.retiraNombreApellidoDisabled}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    sx={{ ml: 2, mb: 1 }}
                    fullWidth
                    inputProps={{
                      autoComplete: "off",
                    }}
                    id="retiraObservaciones"
                    label="Observaciones"
                    variant="outlined"
                    size="small"
                    name="retiraObservaciones"
                    value={entregaArticulos.retiraObservaciones}
                    onChange={handleChangeEntregaArticulos}
                  />
                </Grid>
              </Grid>

            </Box>

            <Grid item xs={12}>
              <Box sx={{ display: "flex", justifyContent: "flex-end", mr: 1 }}>
                <Button
                  // sx={{ mt: 1, mb: 1, mr: 1 }}
                  variant="contained"
                  onClick={handleSave}
                // startIcon={<AddCircleOutlineOutlinedIcon />}
                >
                  Entregar Artículos
                </Button>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                sx={{ mb: 1, ml: 2 }}
              >
                Entregas realizadas
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ ml: 2, mr: 2, mb: 1 }}>
                <DataGrid
                  rows={entregasArticulosRows}
                  columns={entregasArticulosTableColumns}
                  {...tableOptions}
                />
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Box >

      {/* >>>> Dialog entrega de articulo */}

      {
        openDialogEntregaArticulo && (
          <EntregaArticuloDialog
            articuloAEntregar={articuloAEntregar}
            setArticuloAEntregar={setArticuloAEntregar}
            onSave={handleEntregaArticuloDialogSave}
            onClose={handleEntregaArticuloDialogClose}
            setMessage={setMessage}
            setShowMessage={setShowMessage}
          />
        )
      }

      {/* >>>> Dialog detalles de entrega */}

      {
        openDialogEntregaDetalle && (
          <EntregaDetalleDialog
            entregaArticulosDetalle={entregaArticulosDetalle}
            action={entregaArticulosAction}
            onClose={handleEntregaDetalleDialogClose}
            setMessage={setMessage}
            setShowMessage={setShowMessage}
          />
        )
      }

      {/* >>>> Messages */}

      {
        showMessage && (
          <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
        )
      }
    </>
  );
};
export default EntregaArticulos;
